// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper--lh8fb"};